<template>
  <b-row>
    <b-col cols="12">
      <b-btn variant="danger" @click.stop="backToDashboard()">Return to Dashboard</b-btn>
      <hr>
      <b-jumbotron>
        <b-form @submit="onSubmit">
          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Title:">
            <b-form-input required id="title" v-model.trim="post.title"></b-form-input>
          </b-form-group>
          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Date:">
              <b-form-input required id="DateTime" type="date" v-model.trim="post.DateTime"></b-form-input>
          </b-form-group>

          <!--<b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Position:">
            <b-form-select required id="position" v-model.trim="post.position">
              <option value="President">President</option>
              <option value="Vice President">Vice President</option>
              <option value="Secretary">Secretary</option>
              <option value="Treasurer">Treasurer</option>
            </b-form-select>
          </b-form-group>-->

          <!--<b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Author:">
            <b-form-input required id="Author" v-model.trim="post.Author"></b-form-input>
          </b-form-group>-->

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Details:">
            <b-form-textarea required id="details"
                        v-model="post.details"
                        :rows="10"
                        :max-rows="25">
                        {{post.details}}
            </b-form-textarea>
          </b-form-group>

          <b-button type="submit" variant="primary">Save</b-button>
        </b-form>
      </b-jumbotron>
    </b-col>
  </b-row>
</template>

<script>

import firebase from '../Firebase'
import router from '../router/index.js'

export default {
  name: 'AddPost',
  data () {
    return {
      postRef: firebase.firestore().collection('posts'),
      currentUser: firebase.auth().currentUser,
      post: {},
      scrolled: false
    }
  },
  mounted() {
    var user = firebase.firestore().collection('users').doc(this.currentUser.email).get().then (
        docSnapshot => {
          if (!docSnapshot.exists) return;
          let data = docSnapshot.data();

          var name = data.name;
          var position = data.position;

          this.post.Author = name;
          this.post.position = position;
        })
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()

        this.postRef.add(this.post).then((docRef) => {
          this.post.title = ''
          this.post.description = ''
          this.post.Author = ''
          this.post.position = ''
          
          router.push({
          name: 'Dashboard'
          })
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },

    backToDashboard() {
      router.push({ name: 'Dashboard'})
    }
  }
}
</script>

<style>
  .jumbotron {
    padding: 2rem;
  }
</style>